<lib-auth-ui-frm-login
  #vcCoreLoginComponent
  tittle1="Sistema de administracion dgacontrol"
  tittle2=""
  (evtLoginSubmit)="onSubmit($event)"
></lib-auth-ui-frm-login>
